"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EntityActions;
(function (EntityActions) {
    EntityActions["beginInsert"] = "entity.beginInsert";
    EntityActions["commitInsert"] = "entity.commitInsert";
    EntityActions["insertResult"] = "entity.insertResult";
    EntityActions["update"] = "entity.update";
    EntityActions["updating"] = "entity.updating";
    EntityActions["updated"] = "entity.updated";
    EntityActions["delete"] = "entity.delete";
    EntityActions["deleting"] = "entity.deleting";
    EntityActions["deleted"] = "entity.deleted";
    EntityActions["fetch"] = "entity.fetch";
    EntityActions["fetching"] = "entity.fetching";
    EntityActions["fetched"] = "entity.fetched";
    EntityActions["query"] = "entity.query";
    EntityActions["querying"] = "entity.querying";
    EntityActions["queried"] = "entity.queried";
    EntityActions["selectAll"] = "entity.selectAll";
    EntityActions["select"] = "entity.select";
})(EntityActions = exports.EntityActions || (exports.EntityActions = {}));
exports.beginQuery = function (target, query, asyncKey, skip, take) { return ({
    type: EntityActions.query,
    target: target,
    query: query,
    asyncKey: asyncKey,
    skip: skip,
    take: take
}); };
exports.beginUpdate = function (target, entity, asyncKey) { return ({
    type: EntityActions.update,
    target: target,
    entity: entity,
    asyncKey: asyncKey
}); };
exports.beginDelete = function (target, entity, asyncKey) { return ({
    type: EntityActions.delete,
    target: target,
    entity: entity,
    asyncKey: asyncKey
}); };
exports.queryResult = function (target, items) { return ({
    type: EntityActions.queried,
    items: items,
    target: target,
    hasMore: items && items.length > 0
}); };
exports.beginInsert = function (target, entity) { return ({
    type: EntityActions.beginInsert,
    target: target,
    entity: entity
}); };
exports.selectEntity = function (target, entity, select) { return ({
    type: EntityActions.select,
    target: target,
    entity: entity,
    select: select
}); };
exports.selectAll = function (target, select) { return ({
    type: EntityActions.selectAll,
    target: target,
    select: select
}); };
//# sourceMappingURL=entity.js.map